// extracted by mini-css-extract-plugin
export default {"row":"MPIatFkmRVjOHgOYXG3_","discountChip":"wSjpWLsnEOWT2ytPF_3F"};